import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Autocomplete from "@mui/material/Autocomplete";
import { AlertContext } from "../../context/AlertContext";
import { ServiciosContext } from "../../context/ServiciosContext";
import { ConfiguracionContext } from "../../context/ConfiguracionContext";
import { ThemeProvider, createMuiTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/material/styles";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import Spinner from "./Spinner";
import { AuthContext } from "../../context/AuthContext";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import ButtonMui from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Navigate, useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import Menu from "./Menu";
import { MultiSelect } from "primereact/multiselect";

export default function ConfiguracionesEnvios(props) {
  const [globalFilter, setGlobalFilter] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  let navigate = useNavigate();

  const exportColumns = [
    { title: "ID", dataKey: "id" },
    { title: "Descripción", dataKey: "descripcion" },
    { title: "Habilitado", dataKey: "habilitado" },
  ];

  /*
  const cobradores = [
    { id: 83 },
    { id: 84 },
    { id: 96 },
  ];

    const formasPagos = [
    { id: 2 },
    { id: 3 },
    { id: 4 },
    { id: 5 },
    { id: 6 },
    { id: 10 },
    { id: 12 },
  ];
  */

  const tiposEnvios = [
    { title: "Facturación", dataKey: "fa" },
    { title: "Recordatorio 1", dataKey: "r1" },
    { title: "Recordatorio 2", dataKey: "r2" },
  ];

  const [envio, guardarEnvio] = useState(null);
  const [cobrador, guardarCobrador] = useState([]);
  const [formaPago, guardarFormaPago] = useState([]);
  const [empresa, guardarEmpresa] = useState([]);
  const [tipoEnvio, guardarTipoEnvio] = useState(null);
  const [visible, setVisible] = useState(false);
  const [detalle, guardarDetalle] = useState(null);
  const [fecha, guardarFecha] = useState(null);
  const [email, guardarEmail] = useState(null);
  const [whatsapp, guardarWhatsApp] = useState(null);
  const toast = useRef(null);

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const {
    statusAcceso,
    envios,
    empresas,
    cobradores,
    formasPagos,
    obtenerEnvios,
    obtenerAcceso,
    agregarEnvio,
    actualizarEnvio,
    obtenerCobradores,
    obtenerFormasPagos,
    obtenerEmpresas,
  } = configuracionContext;

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({ usuarioId: state.usuario.id, layout: "Configuraciones" });
    }
  }, [state]);

  useEffect(() => {
    obtenerEnvios();
    obtenerCobradores();
    obtenerFormasPagos();
    obtenerEmpresas();
  }, []);

  const editClick = (e) => {
    if (selectedRow) {
      let cob = [];
      if (selectedRow.cobradores) {
        const array = selectedRow.cobradores.split(",");
        for (var i = 0; i < array.length; i++) {
          let dato = cobradores.find((item) => item.id === Number(array[i]));
          cob.push(dato);
        }
      }

      let fpag = [];
      if (selectedRow.formasPagos) {
        const array2 = selectedRow.formasPagos.split(",");
        for (var i = 0; i < array2.length; i++) {
          let dato = formasPagos.find((item) => item.id === Number(array2[i]));
          fpag.push(dato);
        }
      }

      let emp = [];
      if (selectedRow.empresas) {
        const array = selectedRow.empresas.split(",");
        for (var i = 0; i < array.length; i++) {
          let dato = empresas.find((item) => item.id === Number(array[i]));
          emp.push(dato);
        }
      }

      let tEnv = null;
      if (selectedRow.tipoEnvio) {
        let dato = tiposEnvios.find(
          (item) => item.dataKey === selectedRow.tipoEnvio
        );
        tEnv = dato;
      }

      guardarCobrador(cob);
      guardarFormaPago(fpag);
      guardarTipoEnvio(tEnv);
      guardarEmpresa(emp);

      guardarEnvio(selectedRow);
      setVisible(true);
    } else {
      toast.current.show({
        severity: "info",
        summary: "Editar",
        detail: "Debe seleccionar un envío.",
        life: 3000,
      });
    }
  };

  const addClick = (e) => {
    //props.history.push(`/Envio/0`);
    setVisible(true);
    setSelectedRow(null);
    guardarEnvio({
      dia: null,
      periodoVigente: false,
      cobradores: null,
      formasPagos: null,
      tipoEnvio: null,
      empresas: null,
    });
    guardarCobrador([]);
    guardarFormaPago([]);
    guardarTipoEnvio(null);
    guardarEmpresa([]);
  };

  const exitClick = (e) => {
    navigate("/");
  };

  const onHide = (e) => {
    setVisible(false);
  };

  const aceptarClick = (e) => {
    e.preventDefault();
    //Validar
    if (
      !envio ||
      envio.dia === undefined ||
      envio.dia === null ||
      envio.dia === "" ||
      envio.dia === 0
    ) {
      mensajeAlerta("Envíos", "Día es necesario !.", "error");
      return;
    }
    if (cobrador && cobrador.length === 0) {
      mensajeAlerta("Envíos", "Cobradores es necesario !.", "error");
      return;
    }

    if (formaPago && formaPago.length === 0) {
      mensajeAlerta("Envíos", "Formas de Pago es necesario !.", "error");
      return;
    }

    if (empresa && empresa.length === 0) {
      mensajeAlerta("Envíos", "Empresas es necesario !.", "error");
      return;
    }

    if (
      !tipoEnvio ||
      tipoEnvio === undefined ||
      tipoEnvio === null ||
      tipoEnvio === "" ||
      tipoEnvio === 0
    ) {
      mensajeAlerta("Envíos", "Tipo de envío es necesario !.", "error");
      return;
    }

    if (
      (!email ||
      email === undefined) &&
      (!whatsapp ||
      whatsapp === undefined)
    ) {
      mensajeAlerta("Envíos", "Debe indicar email y/o WhatsApp !.", "error");
      return;
    }


    // Llamar al context
    if (selectedRow) {
      actualizarEnvio({
        envio,
        cobrador,
        formaPago,
        tipoEnvio,
        empresa,
        email,
        whatsapp,
      });
    } else {
      agregarEnvio({
        envio,
        cobrador,
        formaPago,
        tipoEnvio,
        empresa,
        email,
        whatsapp,
      });
    }
    onHide();
    setSelectedRow(null);
    setTimeout(() => {
      obtenerEnvios();
    }, 2000);
    //exitClick();
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Envios",
      "No tiene permiso para acceder a esta pantalla !.",
      "error"
    );
    exitClick();
    return;
  };

  const periodoTemplate = (rowData) => {
    return (
      <Fragment>
        <Checkbox checked={rowData.periodoVigente}></Checkbox>
      </Fragment>
    );
  };

  const tipoEnvioTemplate = (rowData) => {
    if (rowData.tipoEnvio) {
      return <Fragment>{rowData.tipoEnvio.toUpperCase()}</Fragment>;
    }
  };

  const emailTemplate = (rowData) => {
    return (
      <Fragment>
        {" "}
        <Checkbox checked={rowData.email}></Checkbox>
      </Fragment>
    );
  };
  const whatsAppTemplate = (rowData) => {
    return (
      <Fragment>
        {" "}
        <Checkbox checked={rowData.whatsapp}></Checkbox>
      </Fragment>
    );
  };

  const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(exportColumns, envios);
        window.open(doc.output("bloburl"));
      });
    });
  };

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(envios);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      saveAsExcelFile(excelBuffer, "envios");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      return new Promise((resolve) => {
        saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
        resolve(true);
      });
    });
  };

  const header = (
    <Fragment>
      <div className="p-d-flex export-buttons">
        <Button
          type="button"
          icon="pi pi-file-excel"
          onClick={exportExcel}
          className="p-button-success p-mr-2"
          data-pr-tooltip="XLS"
        />
        <Button
          type="button"
          icon="pi pi-file-pdf"
          onClick={exportPdf}
          className="p-button-warning p-mr-2"
          data-pr-tooltip="PDF"
          style={{ marginRight: "1em" }}
        />
        <span
          style={{ marginLeft: "1em", marginRight: "1em" }}
          className="p-input-icon-left"
        >
          <i className="pi pi-search" />
          <InputText
            type="search"
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Buscar"
          />
        </span>
        <Tag value="Envios"></Tag>
      </div>
    </Fragment>
  );

  const renderHeader = () => {
    return (
      <div>
        <Tag value="Envio"></Tag>
      </div>
    );
  };

  const renderFooter = () => {
    return (
      <div>
        <ButtonMui
          onClick={aceptarClick}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        <ButtonMui
          onClick={onHide}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  //console.log(envios);
  //console.log(state);

  return (
    <Fragment>
      <Menu />
      <Toast ref={toast} />
      {statusAcceso === 0 ? <Spinner /> : null}
      {statusAcceso === 400 ? accesoDenegado() : null}
      {statusAcceso === 200 ? (
        <Fragment>
          {envios ? (
            <Fragment>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                style={{ align: "center", margin: "1em" }}
              >
                <Button
                  icon="pi pi-plus"
                  tooltip="Agregar"
                  className="p-button-rounded p-button-help"
                  style={{ marginLeft: "0em" }}
                  onClick={addClick}
                />
                <Button
                  icon="pi pi-pencil"
                  tooltip="Editar"
                  className="p-button-rounded p-button-danger"
                  style={{ marginLeft: "1em" }}
                  onClick={editClick}
                />
                <Button
                  icon="pi pi-times"
                  tooltip="Cerrar"
                  className="p-button-rounded p-button-primary"
                  style={{ marginLeft: "1em" }}
                  onClick={exitClick}
                />
                <div className="datatable-responsive-demo">
                  <div className="card">
                    <Tooltip
                      target=".export-buttons>button"
                      position="bottom"
                    />
                    <DataTable
                      value={envios}
                      selection={selectedRow}
                      onSelectionChange={(e) => setSelectedRow(e.value)}
                      selectionMode="single"
                      dataKey="id"
                      header={header}
                      className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-demo"
                      style={{ fontSize: "small", marginTop: "1vw" }}
                      globalFilter={globalFilter}
                      emptyMessage="No hay datos."
                      paginator
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                      rows={10}
                      rowsPerPageOptions={[10, 20, 50]}
                      //paginatorLeft={paginatorLeft}
                      //paginatorRight={paginatorRight}
                    >
                      <Column
                        field="id"
                        header="ID"
                        //body={idTemplate}
                        sortable
                      ></Column>
                      <Column
                        field="dia"
                        header="Día"
                        //body={idTemplate}
                        sortable
                      ></Column>
                      <Column
                        field="periodo"
                        header="Período Vigente"
                        body={periodoTemplate}
                        sortable
                      ></Column>
                      <Column
                        field="cobradores"
                        header="Cobradores"
                        //body={habilitadoTemplate}
                        sortable
                      ></Column>
                      <Column
                        field="formasPagos"
                        header="Formas de Pago"
                        //body={habilitadoTemplate}
                        sortable
                      ></Column>
                      <Column
                        field="empresas"
                        header="Empresas"
                        //body={habilitadoTemplate}
                        sortable
                      ></Column>
                      <Column
                        field="tipoEnvio"
                        header="Tipo Envío"
                        body={tipoEnvioTemplate}
                        sortable
                      ></Column>
                      <Column
                        field="email"
                        header="Email"
                        body={emailTemplate}
                        sortable
                      ></Column>
                      <Column
                        field="whatsapp"
                        header="WhatsApp"
                        body={whatsAppTemplate}
                        sortable
                      ></Column>
                    </DataTable>
                  </div>
                </div>
              </Grid>
              <Dialog
                header={renderHeader()}
                visible={visible}
                closable={false}
                footer={renderFooter()}
                breakpoints={{ "960px": "75vw" }}
                style={{ width: "50vw", paddingBottom: "0" }}
                position="center"
              >
                <Grid container spacing={3} style={{ marginTop: "1vw" }}>
                  {selectedRow ? (
                    <Grid item xs={12} md={2}>
                      <TextField
                        value={envio ? envio.id : null}
                        required
                        variant="standard"
                        id="id"
                        label="ID"
                        fullWidth
                        disabled
                      />
                    </Grid>
                  ) : null}
                  <Grid item xs={12} md={3}>
                    <TextField
                      value={envio ? envio.dia : null}
                      required
                      variant="standard"
                      id="dia"
                      type="Number"
                      label="Día"
                      fullWidth
                      onChange={(e) => {
                        if (e.target.value < 1 || e.target.value > 31) {
                          guardarEnvio({
                            ...envio,
                            dia: 1,
                          });
                        } else {
                          guardarEnvio({
                            ...envio,
                            dia: e.target.value,
                          });
                        }
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={6} style={{ paddingLeft: 0 }}>
                    <FormControlLabel
                      value="yes"
                      control={
                        <Checkbox
                          color="primary"
                          checked={envio ? envio.periodoVigente : null}
                          style={{ marginLeft: "1vw" }}
                          onChange={(e) =>
                            guardarEnvio({
                              ...envio,
                              periodoVigente: e.target.checked,
                            })
                          }
                        />
                      }
                      label="Solo Período Vigente"
                      labelPlacement="start"
                      style={{ paddingLeft: ".7vw" }}
                    />
                  </Grid>
                  <Grid item xs={12} md={10}>
                    <label htmlFor="id">Cobradores</label>

                    <MultiSelect
                      value={cobrador}
                      onChange={(e) => guardarCobrador(e.value)}
                      options={cobradores ? cobradores : null}
                      optionLabel="nombre"
                      placeholder="Seleccione los cobradores"
                      maxSelectedLabels={10}
                      display="chip"
                      style={{ marginLeft: "1vw" }}
                      //className="w-full md:w-40rem"
                    />
                  </Grid>
                  <Grid item xs={12} md={10}>
                    <label htmlFor="id">Formas de Pago</label>

                    <MultiSelect
                      value={formaPago}
                      onChange={(e) => guardarFormaPago(e.value)}
                      options={formasPagos ? formasPagos : null}
                      optionLabel="nombre"
                      placeholder="Seleccione formas de pago"
                      maxSelectedLabels={10}
                      display="chip"
                      style={{ marginLeft: "1vw" }}
                      //className="w-full md:w-40rem"
                    />
                  </Grid>

                  <Grid item xs={12} md={10}>
                    <label htmlFor="id">Empresas</label>

                    <MultiSelect
                      value={empresa}
                      onChange={(e) => guardarEmpresa(e.value)}
                      options={
                        empresas
                          ? empresas.filter(
                              (item) => item.habilitado && item.pdf
                            )
                          : null
                      }
                      optionLabel="nombre"
                      placeholder="Seleccione las Empresas"
                      maxSelectedLabels={10}
                      display="chip"
                      style={{ marginLeft: "1vw" }}
                      //className="w-full md:w-40rem"
                    />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    md={6}
                    style={{ marginLeftLeft: "1vw", marginTop: "0em" }}
                  >
                    <Autocomplete
                      id="tipoEnvio"
                      fullWidth
                      value={tipoEnvio}
                      options={tiposEnvios}
                      disablePortal
                      getOptionLabel={(option) => option.title}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Tipo de envío"
                          variant="standard"
                        />
                      )}
                      //onKeyDown={handleEnter}
                      onChange={(event, value) => {
                        if (value) {
                          guardarTipoEnvio(value);
                        } else {
                          guardarTipoEnvio(null);
                        }
                      }}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    md={6}
                  />

                                    <Grid item xs={12} md={3} style={{ paddingLeft: 0 }}>
                    <FormControlLabel
                      value="yes"
                      control={
                        <Checkbox
                          color="primary"
                          checked={email ? email : null}
                          style={{ marginLeft: "1vw" }}
                          onChange={(e) =>
                            guardarEmail(e.target.checked)
                          }
                        />
                      }
                      label="Email"
                      labelPlacement="start"
                      style={{ paddingLeft: ".7vw" }}
                    />
                  </Grid>
                  <Grid item xs={12} md={3} style={{ paddingLeft: 0 }}>
                    <FormControlLabel
                      value="yes"
                      control={
                        <Checkbox
                          color="primary"
                          checked={whatsapp ? whatsapp : null}
                          style={{ marginLeft: "1vw" }}
                          onChange={(e) =>
                            guardarWhatsApp(e.target.checked)
                          }
                        />
                      }
                      label="WhatsApp"
                      labelPlacement="start"
                      style={{ paddingLeft: ".7vw" }}
                    />
                  </Grid>

                </Grid>
              </Dialog>
            </Fragment>
          ) : (
            <Spinner />
          )}
          <Grid item xs={12} sm={12}></Grid>
        </Fragment>
      ) : null}
    </Fragment>
  );
}

/* class="MuiDataGrid-cell MuiDataGrid-cellLeft" */
